import type { SearchCriteriaParams } from '@/shared/model';

export default function getLastSearchCriteria(key?: string): SearchCriteriaParams | null {
  if (!key) return null;
  if (typeof localStorage === 'undefined') {
    return null;
  }
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || 'null');
    return parsed || null;
  } catch {
    return null;
  }
}
